window.axios = require('axios');
window.Vue = require('vue');
window.Glightbox = require('glightbox');

require('glightbox/dist/css/glightbox.min.css');
require('./swiped');
require('lazysizes');

import AOS from 'aos';
import 'aos/dist/aos.css';

import Search from './components/Search.vue';
import Contact from './components/Contact.vue';

Vue.config.productionTip = false;

new Vue({
    components: {
        Search,
        Contact,
    },
}).$mount('#app');

AOS.init({
    duration: 1000,
});

// var grid = document.querySelector('.grid');

// function onImagesLoaded(callback) {
//     let images = document.querySelectorAll('.grid img');
//     for (let image of images) {
//         if (!image.complete) {
//             setTimeout(onImagesLoaded, 150, callback);
//             return;
//         }
//     }
//     callback();
// }

// if (typeof(grid) != 'undefined' && grid != null) {
//     let masonry = () => {
//         grid.classList.remove('grid_not_loaded');
//         new Masonry( grid, {
//             columnWidth: '.grid__item',
//             height: 'auto',
//             itemSelector: '.grid__item',
//             transitionDuration: '0.1s'
//         })
//     }
//     onImagesLoaded(masonry);
// }

window.showMenu = function() {
    let menu = document.getElementById('menu');
    menu.classList.toggle('hidden')
    menu.classList.toggle('flex')
}